import { TooltipProps } from "recharts";
import moment from "moment";
import { NameType, ValueType } from "recharts/types/component/DefaultTooltipContent";
// MUI
import { Typography } from "@mui/material";

export const ChartLineTooltip = <TValue extends ValueType>({ payload }: TooltipProps<TValue, NameType>) => {
	if (!payload?.length) {
		return null;
	}

	const months = moment.months();
	const getMonth = payload[0].payload.key;

	return (
		<div className="font-sans-bold text-default p-[5px] rounded-[5px] w-[120px] h-[100px] bg-white flex items-center justify-center">
			<ul className="p-0 m-0">
				<Typography className="!font-sans !text-[14px] !pr-[10px]">{months[getMonth]}</Typography>
				{payload?.map((item) => (
					<li className="flex justify-between items-center" key={item.name}>
						<Typography className="!font-sans !text-[14px] !pr-[10px]">{item.name}</Typography>
						<Typography
							className="!font-sans !text-[14px]"
							sx={{
								color: item.color,
							}}
						>
							{item.value}
						</Typography>
					</li>
				))}
			</ul>
		</div>
	);
};
